import { useContext } from "react";
import { resumeActionTypes } from "../reducer/resume-reducer";
import { ResumeContext } from "../resume-context";

function useResumeIntroductionHandler() {
    const { dispatch } = useContext( ResumeContext );
    return {
        handleChange: ( value ) => {
            dispatch(
                {
                    type: resumeActionTypes.CHANGE_DOCUMENT_INTRODUCTION,
                    payload: value
                }
            );
        },
    }
}

export default useResumeIntroductionHandler
